import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AUTH_REASON } from 'src/app/angular-wallet-base/constants';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { PinModalComponent } from 'src/app/components/pin-modal/pin-modal.component';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
@Component({
  selector: 'app-otc3',
  templateUrl: './otc3.component.html',
  styleUrls: ['./otc3.component.scss'],
})
export class Otc3Component implements OnInit {
  public currentTab: string = 'my-orders';
  public isDesktopMode: boolean = true;
  public wallet: any = null;
  markdownContent: SafeHtml | undefined;

  constructor(
    public appMode: AppModeService,
    private oneInchService: OneInchService,
    private modalController: ModalController,
    private navController: NavController,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
  }

  async ngOnInit() {
    this.loadMarkdown();

    await this.oneInchService.initiateConnection();
    await this.openPinModal();
  }

  loadMarkdown(): void {
    this.http.get('assets/terms-of-use.md', { responseType: 'text' }).subscribe((data) => {
      const html = marked(data); // Convert Markdown to HTML
      this.markdownContent = this.sanitizer.bypassSecurityTrustHtml(html); // Sanitize HTML
    });
  }

  private async openPinModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.OTC3_CONNECT_SIGN,
      },
      id: 'pinModal',
    });

    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.wallet = await this.oneInchService.getWallet(data.pin);
  }

  segmentChanged(event) {}

  goBack() {
    this.navController.back();
  }
}
